export default __webpack_public_path__ + "static/media/C01_Icon.b7c45eca.png";